import React from 'react';
export const Messages = _ref => {
  let {
    color = 'currentColor',
    size = '24',
    strokeWidth = '2'
  } = _ref;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: "100%",
    viewBox: "0 0 102 92",
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M37.5 51.8h-5.1L15.6 68.5V51.8H6c-2.2 0-3.9-1.7-3.9-3.9V5.8c0-2.1 1.8-3.9 3.9-3.9h73.1c2.2 0 3.9 1.7 3.9 3.9v23.4"
  }), React.createElement("path", {
    d: "M72.9 71.8l16.9 18.3V71.8H96c2.1 0 3.9-1.7 3.9-3.8V42.3c0-2.1-1.8-3.9-3.9-3.9H49.9c-2.2 0-3.9 1.7-3.9 3.9v25.6c0 2.1 1.8 3.9 3.9 3.9h23z"
  }));
};